import ButtonCinestar from 'components/Buttons/ButtonCinestar/ButtonCinestar'
import Typography from 'components/Typography/Typography'
import { useIntl } from 'react-intl'
import './../Modal.scss'

export default function ModalURlError() {
    const intl = useIntl()
    let referer = localStorage.getItem('referer')
    if (!referer || referer === 'undefined') {
        referer = `https://${process.env.REACT_APP_BASE_WEBSALE_TOP_DOMAIN}`
    }
    return (
        <div className="modal-message">
            <div className="window">
                <div className="title-section">
                    <Typography variant={'h1'}>{intl.formatMessage({ id: 'modals.modalUrlError.title' })}</Typography>
                </div>
                <Typography variant={'p'}>{intl.formatMessage({ id: 'modals.modalUrlError.text' })}</Typography>
                <div className="buttons-section">
                    <ButtonCinestar
                        className={'w-50'}
                        onClick={() => (window.location.href = referer)}
                        variant={'primary-v1'}
                    >
                        {intl.formatMessage({ id: 'buttons.back' })}
                    </ButtonCinestar>
                </div>
            </div>
        </div>
    )
}
